import React, { useState, useEffect } from "react";
import { object, array, string } from "prop-types";
import { LazyCollection, LazyLoadImages, Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import { getCollectionTemplate } from "../../get-collection-template";
import {
  getSectionsDataForHeader,
  getDomainSectionInfo,
  getDomainHostUrl,
  trimLastSlash,
  showSectionWithMenuItems,
  googleTagEvents,
} from "../../utils/utils";
import Headline from "../../atoms/Headline";
import SixteenStories1WidgetWithPollAndLoadMore from "../../rows/SixteenStories1WidgetWithPollAndLoadMore";
import SixteenStories3AdWithTagSearchAndLoadMore from "../../rows/SixteenStories3AdWithTagSearchAndLoadMore";
import BigSectionName from "../../atoms/BigSectionName";
import SubSectionsMenuItems from "../../atoms/SubSectionsMenuItems";
import { useAutoRefresh } from "../../utils/react-utils";

import "./section.m.css";

const SectionPageBase = ({ data: { collection }, sections, domainSlug, domainMenuItemsObj, language, domains }) => {
  const [domainStyleName, setDomainStyleName] = useState("");
  const [domainSectionObj, setSectionDomainObj] = useState({});
  const [sectionsDataForHeader, setSectionsDataForHeader] = useState(null);
  const [device, setDevice] = useState("mobile");
  const stories = collection.items.filter((item) => item.type === "story");
  const collectionSlug = collection.slug;
  const widgetUrl = get(collection, ["metadata", "section-page-widget-url"], null);
  const widgetHeight = get(collection, ["metadata", `height-for-${device}`], null);

  useEffect(() => {
    setSectionDomainObj(getDomainSectionInfo(domainSlug, sections));
    return setDomainStyleName("");
  }, [domainSlug]);

  useEffect(() => {
    const sectionsData =
      collection.template !== "default"
        ? getSectionsDataForHeader(
            sections,
            domainSlug,
            collection.metadata.section,
            getDomainSectionInfo(domainSlug, sections)
          )
        : null;
    setSectionsDataForHeader(sectionsData);
  }, []);

  useEffect(() => {
    if (global.deviceWidth > 875) {
      setDevice("desktop");
    }
  }, []);

  useAutoRefresh(collectionSlug);

  // NTG
  const [scroll, setScroll] = useState(0);
  const scrollEventTrigger = (value) => {
    googleTagEvents("article-milestone", collectionSlug, value);
  };
  useEffect(() => {
    const scrollCalculate = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.offsetHeight;
      const winHeight = window.innerHeight;
      const scrollPercent = scrollTop / (docHeight - winHeight);
      const scrollPercentRounded = Math.round(scrollPercent * 100);
      if (scrollPercentRounded >= 25 && scrollPercentRounded < 50) {
        if (scroll < 25) {
          setScroll(25);
          scrollEventTrigger(25);
        }
      } else if (scrollPercentRounded >= 50 && scrollPercentRounded < 75) {
        if (scroll < 50) {
          setScroll(50);
          scrollEventTrigger(50);
        }
      } else if (scrollPercentRounded >= 75 && scrollPercentRounded < 90) {
        if (scroll < 75) {
          setScroll(75);
          scrollEventTrigger(75);
        }
      } else if (scrollPercentRounded >= 90) {
        if (scroll < 90) {
          setScroll(90);
          scrollEventTrigger(100);
        }
      }
    };
    if (window) {
      window.addEventListener("scroll", scrollCalculate);
      return () => {
        window.removeEventListener("scroll", scrollCalculate);
      };
    }
  }, [scroll]);

  if (!sectionsDataForHeader && collection.template !== "default") {
    return null;
  }

  const menuItemsObject =
    domainMenuItemsObj.length > 0 ? domainMenuItemsObj.filter((item) => item.title === "sections") : null;
  const sectioPageMenuItems = menuItemsObject && menuItemsObject.length > 0 ? menuItemsObject[0].children : null;

  const parentSectionMenuItem =
    sectionsDataForHeader && sectioPageMenuItems && sectioPageMenuItems.length > 0
      ? sectionsDataForHeader && sectionsDataForHeader.parentSection
        ? domainSlug &&
          trimLastSlash(getDomainHostUrl(domainSlug, domains)) === trimLastSlash(sectionsDataForHeader.parentSectionUrl)
          ? sectioPageMenuItems.find(
              (item) => trimLastSlash(item.completeUrl) === trimLastSlash(sectionsDataForHeader.currentSectionUrl)
            )
          : sectioPageMenuItems.find(
              (item) => trimLastSlash(item.completeUrl) === trimLastSlash(sectionsDataForHeader.parentSectionUrl)
            )
        : sectioPageMenuItems.find(
            (item) => trimLastSlash(item.completeUrl) === trimLastSlash(sectionsDataForHeader.currentSectionUrl)
          )
      : null;

  // Renders the menu items of the section

  const getSmallSectionName = () => {
    if (domainSlug && sectionsDataForHeader.parentSectionId === domainSectionObj.id) {
      return null;
    }
    return (
      sectionsDataForHeader &&
      sectionsDataForHeader.parentSection && (
        <Link href={sectionsDataForHeader.currentSectionUrl}>
          <Headline headerLevel={2} headlineType={4} text={sectionsDataForHeader.currentSection} />
        </Link>
      )
    );
  };

  const defaultCollectionName = () => (
    <div
      id="section-meta-wrapper"
      styleName={`section-meta-wrapper ${domainStyleName}`}
      className="section-meta-wrapper"
    >
      <div styleName="section-headers">
        <Headline headerLevel={1} headlineType={9} text={collection.name} styleName={`${language}-collection-name`} />
      </div>
    </div>
  );

  const sectionWithMenuItems = () => (
    <div
      id="section-meta-wrapper"
      styleName={`section-meta-wrapper ${domainStyleName}`}
      className="section-meta-wrapper"
    >
      {showSectionWithMenuItems(sectionsDataForHeader) && (
        <>
          <div styleName="section-headers" className="section-headers">
            <BigSectionName
              domainSectionObj={domainSectionObj}
              domainSlug={domainSlug}
              sectionsDataForHeader={sectionsDataForHeader}
              src="section"
              language={language}
            />
            {getSmallSectionName()}
          </div>
          <SubSectionsMenuItems sectionsDataForHeader={sectionsDataForHeader} src="section" language={language} />
        </>
      )}
    </div>
  );

  const currentSubSection =
    parentSectionMenuItem && parentSectionMenuItem.children.length > 0
      ? parentSectionMenuItem.children.find((item) => item.completeUrl === sectionsDataForHeader.currentSectionUrl)
      : null;

  const sectionMenuDom = () => (
    <div
      id="section-meta-wrapper"
      styleName={`section-meta-wrapper ${domainStyleName}`}
      className="section-meta-wrapper"
    >
      <div styleName="section-headers" className="section-headers">
        {
          <BigSectionName
            domainSectionObj={domainSectionObj}
            domainSlug={domainSlug}
            sectionsDataForHeader={sectionsDataForHeader}
            src="section"
            language={language}
          />
        }
        {currentSubSection && sectionsDataForHeader && sectionsDataForHeader.parentSection && (
          <Link href={currentSubSection.completeUrl}>
            <Headline
              headerLevel={2}
              headlineType={4}
              text={currentSubSection.title}
              styleName={`${language}-section-name`}
            />
          </Link>
        )}
      </div>
      {parentSectionMenuItem.children.length > 0 ? (
        <ul styleName={`sub-sections ${language}-sub-sections`} className="sub-sections">
          {parentSectionMenuItem.children.slice(0, 12).map((item, index) => (
            <li
              styleName="section"
              className={
                sectionsDataForHeader && sectionsDataForHeader.currentSectionUrl === item.completeUrl
                  ? "current-section"
                  : ""
              }
              key={index}
            >
              {item.completeUrl === "/#" ? (
                <span>{item.title}</span>
              ) : (
                <Link href={item.completeUrl}>{item.title}</Link>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <SubSectionsMenuItems sectionsDataForHeader={sectionsDataForHeader} src="section" language={language} />
      )}
    </div>
  );

  return (
    <div>
      {parentSectionMenuItem
        ? sectionMenuDom()
        : collection.template === "default"
        ? defaultCollectionName()
        : sectionWithMenuItems()}
      <div>
        {collection["data-source"] === "automated" &&
        (collection.template === "default" || collection.template === "section") ? (
          !stories.length ? (
            <div styleName={`no-section-stories ${language}-no-stories`}>No stories found for this section !!</div>
          ) : (
            <div>
              {sectionsDataForHeader && sectionsDataForHeader.parentSection ? (
                <SixteenStories1WidgetWithPollAndLoadMore
                  collectionSlug={collectionSlug}
                  stories={stories}
                  widgetUrl={widgetUrl}
                  widgetHeight={widgetHeight}
                  lang={language}
                />
              ) : (
                <SixteenStories3AdWithTagSearchAndLoadMore
                  collectionSlug={collectionSlug}
                  stories={stories}
                  widgetUrl={widgetUrl}
                  widgetHeight={widgetHeight}
                  lang={language}
                />
              )}
            </div>
          )
        ) : !collection.items.length ? (
          <div styleName={`no-section-stories ${language === "en" ? "en-no-stories" : ""}`}>
            No stories found for this section !!
          </div>
        ) : (
          <LazyLoadImages>
            <LazyCollection collection={collection} collectionTemplates={getCollectionTemplate} lazyAfter={2} />
          </LazyLoadImages>
        )}
      </div>
    </div>
  );
};

SectionPageBase.propTypes = {
  data: object,
  sections: array,
  pageType: string,
  menu: object,
  domainSlug: string,
  domainMenuItemsObj: array,
  language: string,
  domains: array,
};

const mapStateToProps = (state) => ({
  menu: get(state, ["qt", "data", "navigationMenu"], {}),
  sections: get(state, ["qt", "config", "sections"], []),
  domains: get(state, ["qt", "config", "domains"], []),
  pageType: get(state, ["qt", "pageType"], ""),
  domainSlug: get(state, ["qt", "domainSlug"], ""),
  domainMenuItemsObj: get(state, ["qt", "data", "navigationMenu", "menuItems"], []),
  language: get(state, ["qt", "config", "publisher-attributes", "lang"], "en"),
});

export const SectionPage = connect(mapStateToProps, null)(SectionPageBase);
